import { Loader } from "dash-styled"
import { useMemo } from "react"
import { RouteComponentProps } from "react-router"
import { JSONEditor } from "../../Components/Common/Lazy/JSONEditor"
import { SchemaFormPlayground } from "../../Components/Common/Lazy/SchemaFormPlayground"

const noop = () => {}

function JSONEditorAdapter<V>({
    className,
    data,
    setData
}: {
    className?: string
    data: V
    setData: (data: V) => void
}) {
    return (
        <JSONEditor
            className={className}
            initialValue={data}
            value={data}
            onChange={setData}
            fallback={<>Loading...</>}
            onError={noop}
        />
    )
}

export function PlaygroundRoute({ location }: RouteComponentProps<{}>) {
    const decoded = useMemo(() => {
        if (location.hash === "") {
            return {
                formData: "one",
                schema: {
                    type: "string",
                    title: "Sample choice",
                    description: "Please choose from below",
                    enum: ["one", "two", "three"]
                },
                uiSchema: {
                    "ui:help": "This is a help text"
                }
            }
        }

        try {
            return JSON.parse(atob(location.hash.slice(1)))
        } catch (e) {
            return undefined
        }
    }, [location.hash])

    return (
        <SchemaFormPlayground
            fallback={<Loader absolute={true} />}
            className="h-full p-4"
            initialFormData={decoded?.formData}
            initialSchema={decoded?.schema}
            initialUiSchema={decoded?.uiSchema}
            JSONEditor={JSONEditorAdapter}
        />
    )
}
